import { Component, Input } from '@angular/core';
import { DataFieldTypes } from '@app/enums/data-field-types.enum';
import { DataValue } from '@models/employee/data-value.model';
import { DataFieldGroup } from '@models/settings/data-field-group.model';
import { DataField } from '@models/settings/data-field.model';
import { mapValues } from 'lodash-es';

@Component({
    selector: 'app-data-field-group-values',
    templateUrl: './data-field-group-values.template.html',
    styleUrls: ['./data-field-group-values.style.scss'],
})
export class DataFieldGroupValuesComponent {
    @Input() group: DataFieldGroup | null = null;
    @Input() dataFields: DataField[] | null = null;
    @Input() dataValues: DataValue[] | null = null;

    dataFieldTypes = DataFieldTypes;

    // Using private variables allows us to memoize the results so that we are not doing array methods (find and filter) repeatedly via the template
    private _dataFieldsByGroup: DataField[] = [];
    private _dataValuesByDataField: { [key: string]: string | null } = {};

    get dataFieldsByGroup(): DataField[] {
        if (this._dataFieldsByGroup.length || !this.group || !this.dataFields) {
            return this._dataFieldsByGroup;
        }

        this._dataFieldsByGroup = this.dataFields.filter(
            (field: DataField) => field.dataFieldGroup?.id === this.group?.id
        );

        return this._dataFieldsByGroup;
    }

    getDataValueByDataField(field: DataField): string | null {
        if (this._dataValuesByDataField[field.id] || !this.dataValues) {
            return this._dataValuesByDataField[field.id];
        }

        this._dataValuesByDataField[field.id] =
            this.dataValues.find((value) => value.dataFieldId === field.id)?.displayValue ?? null;

        return this._dataValuesByDataField[field.id];
    }

    resetDataValues(): void {
        this._dataValuesByDataField = mapValues(this._dataValuesByDataField, () => null);
    }
}
